module.exports = __webpack_public_path__ + "img/song-promotion-on-music-sites.293613ae.jpg";